.whisperContainer {
    align-self: flex-start;
    top: 0;
    z-index: var(--mantine-priority-highest);
}
